var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.95496C2 7.8338 2.90677 6.92493 4.02532 6.92493H6.34268C6.81648 6.92493 7.27528 6.75843 7.63926 6.45441L11.491 3.2372C12.1505 2.68628 13.1519 3.15639 13.1519 4.01696V19.983C13.1519 20.8436 12.1505 21.3137 11.491 20.7628L7.63926 17.5456C7.27528 17.2416 6.81648 17.0751 6.34268 17.0751H4.02532C2.90676 17.0751 2 16.1662 2 15.045V8.95496Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4177 6.92493C14.4177 6.5045 14.7578 6.16367 15.1772 6.16367C18.3931 6.16367 21 8.77668 21 12C21 15.2233 18.3931 17.8363 15.1772 17.8363C14.7578 17.8363 14.4177 17.4955 14.4177 17.0751C14.4177 16.6546 14.7578 16.3138 15.1772 16.3138C17.5541 16.3138 19.481 14.3825 19.481 12C19.481 9.61755 17.5541 7.68619 15.1772 7.68619C14.7578 7.68619 14.4177 7.34536 14.4177 6.92493Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1772 9.20871C14.7578 9.20871 14.4177 9.54954 14.4177 9.96997C14.4177 10.3904 14.7578 10.7312 15.1772 10.7312C15.8763 10.7312 16.443 11.2993 16.443 12C16.443 12.7007 15.8763 13.2688 15.1772 13.2688C14.7578 13.2688 14.4177 13.6096 14.4177 14.03C14.4177 14.4505 14.7578 14.7913 15.1772 14.7913C16.7152 14.7913 17.962 13.5416 17.962 12C17.962 10.4584 16.7152 9.20871 15.1772 9.20871Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMedium);
export default __webpack_public_path__ + "static/media/volume-medium.34d37cbcdc891abc08df22abbb9458cf.svg";
export { ForwardRef as ReactComponent };